<section class="dashboard-empty" role="region" aria-labelledby="dashboard-empty-no-project-title">
  <h2 id="dashboard-empty-no-project-title" class="dashboard-empty__title">
    {{ 'liveDashboard.empty.noProjectTitle' | translate }}
  </h2>
  <p class="dashboard-empty__subtitle">{{ 'liveDashboard.empty.noProject' | translate }}</p>
</section>
